import { removeWorkSpaceTab } from "../../../utils/helper/helper";
import { persistor } from '../../../services/store/store';

import Axios from "../../../networking/intraceptor";
import Cookies from "js-cookie";
import { resetAdminStealthCache } from "../../../hooks/useAdminStealth";

export const handleLogoutPharmacy = async (setLoading, navigate) => {
	try {
		setLoading(true)
		const response = await Axios.get(`pharmacy-user-logout`);
		if (response.status === 200) {
			setLoading(false)

			// Clear all cookies
			Object.keys(Cookies.get()).forEach(cookieName => {
				Cookies.remove(cookieName);
			});

			localStorage.removeItem('@oat_p$(sDe)')
			// Drop the admin screen-privacy mirror so the next person to log in
			// on this browser is not briefly rendered with the previous admin's
			// setting. The setting itself is stored against the account, so it
			// still survives this logout and returns at their next login.
			resetAdminStealthCache()
			// Clear all sessionStorage items
			sessionStorage.clear();

			if (typeof BroadcastChannel !== 'undefined') {
				const broadcastChannel = new BroadcastChannel("logout-channel");
				broadcastChannel.postMessage("logout");
				broadcastChannel.close();
			}

			// persistor.purge();
			// window.location.reload();

			// Optional — clear persisted data
			persistor.pause();
			persistor.flush().then(() => {
				persistor.purge(); // only if you want full reset	
				window.location.href = "/";
			});
			removeWorkSpaceTab()
		} else {
			throw new Error(response);
		}
	} catch (error) {
		setLoading(false)
	}
}
